import React, { useEffect } from 'react';
import { graphql } from "gatsby"

import { QueryFragments } from "../GraphQl/queryFragments" // eslint-disable-line

// Hooks, Querys & State
import { useAppState } from "../state/appState"

// Components
import { PageMeta } from "../components/pageMeta"
import BlockZone from "~blockZone"
import { PageBanner } from '../components/blockZone/blocks';
import { Apply } from '../components/ui/apply';

const PageTemplate = ({ data: { page } }) => {
  
  const { meta, banner, pageBlocks, showApply } = page || {}

  const {    
    toggleHeaderLight,
  } = useAppState();

  useEffect(() => {
    toggleHeaderLight(true);
  }, [toggleHeaderLight]);
  

  return (
    <>
      <PageMeta {...meta} />
      {banner && <PageBanner {...banner} />}
      {pageBlocks && <BlockZone {...pageBlocks} />}
      {showApply && <Apply />}
    </>
  );
}

export default PageTemplate

export const pageQuery = graphql`
  query standardPageQuery($slug: String!) {
    page: sanityPage(slug: { current: { eq: $slug } }) {
      banner {
        caption
        heading
        scrollText
        image {
          ...ImageWithPreview
        }
      }
      showApply
      meta {
        ...MetaCardFields
      }
      pageBlocks {
        ...BlockZone
      }
    }
  }
`;
